import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { toast } from 'react-toastify';
// import Loader from "../../../Components/Loader";
import Select from 'react-select';
import {locationServices} from "../../../Services"
import SimpleReactValidator from 'simple-react-validator';
import CourierCountryServices from "../../../Services/CourierCountryServices";


const ProviderOption = [
    { value: 'Fedex', label: 'Fedex'},
    { value: 'Ups', label: 'Ups'},
    { value: 'Dhl', label: 'Dhl'}
]

const serviceOption = [
    { value: 'EXPORT', label: 'Export'},
    { value: 'IMPORT', label: 'Import'}
]

let ObjNum = [];
for (let i = 0; i < 75; i++) {
    ObjNum.push({ value: i, label: i})
}
const ZoneOption = ObjNum

export const EditCourierCountryService = () => {


    const history = useHistory()

    const [, setForceUpdate] = useState('')
    const validator = useRef(new SimpleReactValidator({ autoForceUpdate: { forceUpdate: setForceUpdate } }))

    const [countryList, setCountryList] = useState([])
    
    const [serviceProvider, setServiceProvider] = useState()
    const [zone, setZone] = useState()
    const [serviceType, setServiceType] = useState()
    const [countryItem, setCountryItem] = useState([])

    const countryData = history.location.state

    const getCountryList = () => {
        locationServices.getCountry({ page: 1, limit: 300 }).then((res) => {
          if (res.status) {
            let arry = [];
            res.data.map((list) => {
              arry.push({ value: list._id, label: list.country_name });
            });
            setCountryList(arry);


            let prevId = []
            countryData && countryData.countries.map((val=>{
                res.data.filter(item=>{
                    if(item._id === val._id){
                        prevId.push({value: item._id, label: item.country_name});
                    }
                })
            }))
            setCountryItem(prevId)

          }
        });
      };

    

    useEffect(() => {
        getCountryList();
        getDetails();
    },[])

    const getDetails = () => {
        const previousData = history.location.state
        
        ProviderOption.filter(item=>{
            if(item.value === previousData.service_provider){
                setServiceProvider({value: item.value, label: item.label});
            }
        })

        serviceOption.filter(item=>{
            if(item.value === previousData.service_type){
                setServiceType({value: item.value, label: item.label});
            }
        })

        ZoneOption.filter(item=>{
            if(item.value === previousData.zone){
                setZone({value: item.value, label: item.label});
            }
        })   
    }    

      const submitHandler = (e) =>{
          e.preventDefault();

          let idArry = []
          if(countryItem) {
            countryItem.forEach((item=>{
                idArry.push(item.value)
            }))
        }

         let postData = {
            service_provider: serviceProvider && serviceProvider.value,
            zone: zone && zone.value,
            service_type: serviceType && serviceType.value,
            countries: idArry,
            courier_country_services_id: countryData._id
         }


        const validate = validator.current.allValid()
        if(validate){
            CourierCountryServices.updateCouriercountryApi(postData).then((res) => {
                if (res.status === true) {
                  toast.success('courier country updated successfully');
                  history.push('/courier-country-service')
                }else{
                    toast.error(res.message)
                }
              }).catch(err=>{
                  console.log(err)
              });

        }else{
            validator.current.showMessages();
        }

      }
  


  return (
    <div className="row d-flex justify-content-center">
    <div className="col-lg-8">
        <div className="card">
            <div className="card-body">
            <form className="control-form" onSubmit={(e) => submitHandler(e)}>
                    <div className="row">
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Servie Provider</label>
                            </div>
                            <div className="col-9">
                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            // borderColor: formik.touched.destination_country_id ? !formik.errors.destination_country_id ? '#34c38f' : '#f46a6a' : '#ced4da',
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    value={serviceProvider}
                                    onChange={(e) => setServiceProvider(e)}
                                    placeholder="Select Service Provider"
                                    options={ProviderOption}
                                    isDisabled
                                />
                                {/* {formik.touched.destination_country_id && formik.errors.destination_country_id ? (
                                    <div className="text-danger">{formik.errors.destination_country_id}</div>
                                ) : null} */}

                                {validator.current.message("service provider",serviceProvider,"required",{ className: "text-danger" })}
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Zone</label>
                            </div>
                            <div className="col-9">
                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            // borderColor: formik.touched.destination_country_id ? !formik.errors.destination_country_id ? '#34c38f' : '#f46a6a' : '#ced4da',
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    value={zone}
                                    onChange={(e) => setZone(e)}
                                    placeholder="Select Zone"
                                    options={ZoneOption}
                                    isDisabled
                                />
                                {/* {formik.touched.destination_country_id && formik.errors.destination_country_id ? (
                                    <div className="text-danger">{formik.errors.destination_country_id}</div>
                                ) : null} */}

                                {validator.current.message("zone",zone,"required",{ className: "text-danger" })}
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Service Type</label>
                            </div>
                            <div className="col-9">
                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            // borderColor: formik.touched.destination_country_id ? !formik.errors.destination_country_id ? '#34c38f' : '#f46a6a' : '#ced4da',
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    value={serviceType}
                                    onChange={(e) => setServiceType(e)}
                                    options={serviceOption}
                                    placeholder="Select Service Type"
                                    isDisabled
                                />
                                {/* {formik.touched.destination_country_id && formik.errors.destination_country_id ? (
                                    <div className="text-danger">{formik.errors.destination_country_id}</div>
                                ) : null} */}

                                {validator.current.message("service type",serviceType,"required",{ className: "text-danger" })}
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Countries</label>
                            </div>
                            <div className="col-9">
                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            // borderColor: formik.touched.destination_country_id ? !formik.errors.destination_country_id ? '#34c38f' : '#f46a6a' : '#ced4da',
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    isMulti
                                    value={countryItem}
                                    onChange={(e) => setCountryItem(e)}
                                    options={countryList}
                                    placeholder="Select Countries"
                                    className="customCourierSelect"
                                />
                                {/* {formik.touched.destination_country_id && formik.errors.destination_country_id ? (
                                    <div className="text-danger">{formik.errors.destination_country_id}</div>
                                ) : null} */}

                                {validator.current.message("countries",countryItem,"required",{ className: "text-danger" })}
                            </div>
                        </div>
                       
                    </div>
                    <div className="mt-3 d-flex justify-content-between">
                        <button
                            className="btn btn-danger w-sm waves-effect waves-light"
                            type="button"
                            onClick={() => history.goBack()}
                        >Back</button>
                        <button className="btn btn-primary w-sm waves-effect waves-light"
                            type="submit"
                            
                        >Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
  );
};
